import { render, staticRenderFns } from "./AddAdditionalInformation.vue?vue&type=template&id=2b4d5082&"
import script from "./AddAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports